import styled from "styled-components";
import params from "../../global/params.json";

const containerParams = params.container;

export const Container = styled.div`
  h4 {
    padding: 0 0 10px 10px;
    font-size: 24px;
  }
  padding: 112px 20px 0 20px;
  width: 100%;
  margin: 0 auto;
  .ul-farm-container {
    border-radius: 10px;
    background-color: #1b1e29;
    margin-bottom: 100px;
  }
  .farm-filter-container {
    padding-top: 16px;
    padding-left: 16px;
    padding-right: 16px;
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
    .farm-tab-control {
      display: flex;
      align-items: center;
    }
  }
  .farm-list-container {
    padding: 24px 16px;
  }
  .trading-row {
    display: grid;
    grid-template-columns: 1fr 2fr 1fr;
    gap: 10px;
    margin-bottom: 100px;
  }
  .background-trading {
    position: fixed;
    top: 0;
    left: 0;
    height: 100%;
    width: 100%;
    min-width: 1200px;
    z-index: -1;
  }
  .trading-card {
    background-color: var(--background);
    padding: 20px;
    border-radius: 20px;
    height: unset;
  }

  @media screen and (max-width: 950px) {
    .trading-row {
      grid-template-columns: 1fr;
    }
    .extra-button {
      display: none;
    }
  }

  //unico tabselector

  .jss4790 {
    padding-top: 0px;
    padding-left: 16px;
    padding-right: 16px;
  }
  .jss4791,
  .jss4799 {
    padding-top: 16px;
  }
  .customSelectorWrapper {
    display: flex;
    align-items: center;
  }
  .jss4793,
  .jss4795,
  .jss4798 {
    height: 36px;
  }
  .jss4797 {
    height: 36px;
    margin-right: 8px;
  }
  .customSelector {
    padding: 0 16px;
    display: flex;
    align-items: center;
    cursor: pointer;
    margin-right: 8px;
    transition: all 0.2s;
    small {
      color: #696c80;
    }
  }
  .selectedCustomSelector {
    background-color: #ebecf2;
    border-radius: 8px;
    small {
      color: #1b1e29;
    }
  }

  //search
  .jss4799 {
    width: auto;
    justify-content: center;
    gap: 10px;
  }
  .jss8896 {
    width: 160px;
    margin-top: 0px;
  }
  .jss4804 {
    width: 200px;
    margin-top: 0px;
    margin-left: 0px !important;
  }
  .jss8897 {
    width: 100%;
    height: 40px;
    display: flex;
  }
  .activeSwitchItem {
    background: #252833;
    p {
      color: #c7cad9;
    }
  }
  .switchItem {
    width: 50%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
    border: 1px solid #252833;
    transition: all 0.2;
    .switchItem p {
      color: #696c80;
    }
  }
  .jss4804 {
    width: 200px;
    margin-top: 0px;
    margin-left: 16px;
  }
  .searchInput {
    height: 40px;
    border: 1px solid #3e4252;
    border-radius: 10px;
    display: flex;
    align-items: center;
    padding: 0 10px;
    width: 100%;
    input {
      background: 0 0;
      border: none;
      box-shadow: none;
      outline: none;
      /* font-family: inter, sans-serif; */
      font-size: 14px;
      font-weight: 500;
      color: #c7cad9;
      width: 100%;
    }
  }
  .jss4806 {
    flex: 1 1 0%;
    margin: 0px 8px 0px 0px;
  }

  //category
  .jss8900 {
    margin-top: 16px;
    padding-left: 12px;
  }
  .bg-secondary1 {
    background-color: #252833;
  }
  .customTabWrapper {
    display: flex;
    align-items: center;
  }
  .jss8901 {
    width: 100%;
    height: 50px;
  }
  .MuiTabs-root {
    display: flex;
    overflow: hidden;
    min-height: 48px;
    -webkit-overflow-scrolling: touch;
  }
  .customTabWrapper .MuiTabs-root .MuiTabs-scroller {
    overflow-x: auto !important;
  }
  .MuiTabs-fixed {
    width: 100%;
    overflow-x: hidden;
  }
  .MuiTabs-scroller {
    flex: 1 1 auto;
    display: inline-block;
    position: relative;
    white-space: nowrap;
  }
  .customTabWrapper .MuiTabs-root .MuiTabs-scroller .MuiTabs-flexContainer {
    display: inline;
  }
  .MuiTabs-flexContainer {
    display: flex;
  }
  .customTabWrapper .MuiTabs-root .MuiTabs-indicator {
    background-color: #c7cad9;
  }
  .jss8902 {
    width: 100%;
    bottom: 0;
    height: 2px;
    position: absolute;
    transition: all 300ms cubic-bezier(0.4, 0, 0.2, 1) 0ms;
  }
  .customTabWrapper .MuiTabs-root button {
    min-width: unset;
    max-width: none;
    padding: 6px 0;
    margin: 0 12px;
  }
  .MuiTab-textColorInherit.Mui-selected {
    opacity: 1;
  }
  .MuiTab-textColorInherit {
    color: inherit;
    opacity: 0.7;
  }
  .MuiTab-root {
    padding: 6px 12px;
    overflow: hidden;
    position: relative;
    font-size: 0.875rem;
    max-width: 264px;
    min-width: 72px;
    box-sizing: border-box;
    min-height: 48px;
    text-align: center;
    flex-shrink: 0;
    /* font-family: "Inter", sans-serif; */
    font-weight: 500;
    line-height: 1.75;
    white-space: normal;
    text-transform: uppercase;
  }
  .MuiButtonBase-root {
    color: inherit;
    border: 0;
    cursor: pointer;
    margin: 0;
    display: inline-flex;
    outline: 0;
    padding: 0;
    position: relative;
    align-items: center;
    user-select: none;
    border-radius: 0;
    vertical-align: middle;
    /* -moz-appearance: none; */
    justify-content: center;
    text-decoration: none;
    background-color: transparent;
    /* -webkit-appearance: none; */
    -webkit-tap-highlight-color: transparent;
  }
  .Mui-selected span {
    color: #c7cad9;
  }
  .customTabWrapper .MuiTabs-root button span {
    font-size: 14px;
    color: #696c80;
    text-transform: none;
  }
  .MuiTab-wrapper {
    width: 100%;
    display: inline-flex;
    align-items: center;
    flex-direction: column;
    justify-content: center;
  }
  .MuiTouchRipple-root {
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 0;
    overflow: hidden;
    position: absolute;
    border-radius: inherit;
    pointer-events: none;
  }

  @media (min-width: 700px) {
    .MuiTab-root {
      min-width: 160px;
    }
  }

  //ul header

  .jss10511 {
    margin-top: 16px;
    padding-left: 28px;
    padding-right: 28px;
  }
  .jss10512 {
    width: 90%;
  }
  .jss10514 {
    width: 30%;
    justify-content: flex-start;
  }
  .jss10518 {
    width: 20%;
    justify-content: flex-start;
  }
  .jss10522 {
    width: 30%;
    justify-content: flex-start;
  }
  .jss10526 {
    width: 20%;
    justify-content: flex-start;
  }
  .sortArrows {
    display: flex;
    flex-direction: column;
    div {
      display: flex;
      color: #696c80;
    }
  }
  .jss10517,
  .jss10521,
  .jss10525,
  .jss10529 {
    margin-top: -15px;
  }
  .sortArrows > div.selectedSortArrow {
    color: #c7cad9;
  }
  .MuiSvgIcon-root {
    fill: currentColor;
    width: 1em;
    height: 1em;
    display: inline-block;
    font-size: 1.5rem;
    transition: fill 200ms cubic-bezier(0.4, 0, 0.2, 1) 0ms;
    flex-shrink: 0;
    user-select: none;
  }

  .jss10664 {
    padding-top: 40px;
    padding-bottom: 40px;
  }
  .jss10668 {
    margin-top: 8px;
    margin-bottom: 24px;
  }
  //geral
  .text-secondary {
    color: #696c80;
  }
  .span,
  span {
    font-size: 12px;
    line-height: 1.33;
  }
  .small,
  small {
    font-size: 14px;
    line-height: 1.57;
  }
  .flex-wrap {
    flex-wrap: wrap;
  }
  .justify-between {
    justify-content: space-between;
  }
  .flex {
    display: flex;
  }
  .flex-col {
    flex-direction: column;
  }
  .items-center {
    align-items: center;
  }
  .cursor-pointer {
    cursor: pointer;
  }

  @media screen and (max-width: 700px) {
    padding: 112px 10px 0 10px;
    .jss10511 {
      display: none;
    }
  }
`;
